export default __webpack_public_path__ + "static/patio-v4-3-22a4e15fffd9c1452ea291d47281c501.jpg";